function t() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
  for (var n in r)
    typeof e[n] > "u" && (e[n] = r[n]);
  return e;
}
export {
  t as default
};
//# sourceMappingURL=contact-channels79.js.map
